module.exports = __webpack_public_path__ + "static/media/1.d06ae6d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.mp4
// module id = URub
// module chunks = 13